import React, { useState, useEffect } from 'react'

// import { Recorder } from 'react-voice-recorder'
// import 'react-voice-recorder/dist/index.css'
import Recorder from './Recorder';

import { Dialog, LinearProgress } from "@material-ui/core";

import MicIcon from "@mui/icons-material/Mic";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";

import { ErrorData } from "../../../helpers";
import * as HTTPServices from '../../../api/HTTPServices';
// import useRecorder from "./useRecorder";
import VmsgRecorder from './vmsgRecorder';

function Test(props) {
    const { handleClose, AudienceID, addMessageToList, userId, attachType, roomToken, cancel } = props;
    const [uploadProcess, setUploadProcess] = useState(0);
    const [uploading, setUploading] = useState(false)

    const [audioDetails, setAudioDetails] = useState({
        url: null,
        blob: null,
        chunks: null,
        duration: {
            h: 0,
            m: 0,
            s: 0
        }
    })


    const handleAudioUpload = (file) => {
        const blob = new File(
            [file],
            `${AudienceID}-${userId}-${Date.now().toFixed()}.mp3`,
            { type: 'audio/mp3' }
        );

        let data = new FormData();
        data.append("message", null);
        data.append("audience", AudienceID);
        if (attachType == "prescription") {
            data.append("type", "prescriptionVoice");
        } else {
            data.append("type", "dossierVoice");
        }
        data.append("file", blob);
        data.append("room_token", roomToken);
        setUploading(true)
        const RequestService = HTTPServices.postMethod(
            "chat",
            data,
            "true",
            "post",
            "false",
            "",
            false,
            (ProgressEvent) => {
                setUploadProcess(
                    (ProgressEvent.loaded / ProgressEvent.total) * 100
                );
            },
            () => {
                ErrorData("خطایی در اپلود رخ داد. لطفا مجددا تلاش کنید.");
            },
        );
        RequestService.then(function (response) {
            setUploading(false)
            if (response) {
                // successFullUploadCallBack(response);
                addMessageToList(response.message)
                console.log(response, '0000000000000responsej');
                onClose()
            }
        }).catch(() => {
            setUploading(false)
        })
    }

    const onClose = () => {
        handleReset()
        props.cancel();
    };

    const handleAudioStop = (data) => {
        console.log(data, 'handleAudioStop')
        setAudioDetails(data)
        // this.setState({ audioDetails: data });
    }

    const handleCountDown = (data) => {
        console.log(data, 'handleCountDown');
    }

    const handleReset = () => {
        const reset = {
            url: null,
            blob: null,
            chunks: null,
            duration: {
                h: 0,
                m: 0,
                s: 0
            }
        };
        setAudioDetails(reset)
        // this.setState({ audioDetails: reset });
    }

    return (
        <Dialog open={true} aria-labelledby="form-dialog-title">

            <VmsgRecorder
                timeLimit={180}
                onClose={onClose}
                uploadProcess={uploadProcess}
                uploading={uploading}
                handleAudioUpload={handleAudioUpload}
            />
        </Dialog>
    )
}

export default Test